'use client';
import usePageDrawer from '@/containers/AppDrawer/usePageDrawer';
import AllModals from '@/containers/Modals/AllModalsContainer';
import { ToastContainer } from '@/containers/ToastMessage';
import { IntercomProvider } from '@/lib/intercom';
import { selectIsTokenVerified } from '@/lib/redux/app.selectors';
import AppBlockingLoader from '@/shared/components/Loaders/AppBlockingLoader/AppBlockingLoader';
import useInitialization from '@/shared/hooks/useInitialization';
import useUser from '@/shared/hooks/useUser';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import AuthProtection from './AuthProtection';
import PageWithDrawer from './PageWithDrawer';

interface InitializationProps {
  children?: ReactNode;
}
const Initialization = ({ children }: InitializationProps) => {
  useInitialization();
  const isTokenVerified = useSelector(selectIsTokenVerified);
  const { isLoading } = useUser();
  const { hasPageDrawer } = usePageDrawer();

  if (!isTokenVerified || isLoading) {
    return <AppBlockingLoader />;
  }

  return (
    <IntercomProvider>
      <AuthProtection>
        {hasPageDrawer ? <PageWithDrawer>{children}</PageWithDrawer> : children}
        <AllModals />
        <ToastContainer />
      </AuthProtection>
    </IntercomProvider>
  );
};

export default Initialization;
